export default __webpack_public_path__ + "static/media/14.d7ed5f88.jpg";